import ResourceService from "./resource.service";

class ClientCityService extends ResourceService {
  static get resource() {
    return "client-city";
  }
}

export default ClientCityService;